<router-outlet></router-outlet>

@if (showTestStage()) {
  <ui-test-stage-indicator/>
}

@if (showCookieBanner()) {
  <feat-cookie-banner></feat-cookie-banner>
}
